import React, { useState, useCallback } from "react";
import {
  BeadCrumb,
  CustomHeader,
  Typography,
  TextField,
  Button,
  Modal,
  AddCta,
} from "components";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/routePaths";
import SingleRegistration from "./SingleRegistration";
import BulkRegistration from "./BulkRegistration";
import { IoMdClose } from "react-icons/io";
import { CgCheckR } from "react-icons/cg";
import { AiOutlineDelete } from "react-icons/ai";
import { useDropzone } from "react-dropzone";
import { routes } from "routes/apiRoutes";
import { isSuccessResponse, setAlert } from "utils/helper";
import makeRequest from "services/makeRequest";
import successImg from "assets/images/success-image.png";
import cloudImg from "assets/images/cloud-img.png";
import fileImg from "assets/images/uploaded-img.png";

import "../style.scss";

const RegisterTerminal = () => {
  const [modalContentMapper, setModalContentMapper] = useState(null);
  const [singleRegMode, setSingleRegMode] = useState(true);

  const [responseMessage, setResponseMessage] = useState("");

  const initialFileState = { file: null, fileName: "", error: "" };
  const [uploadedData, setUploadedData] = useState(initialFileState);

  const handleClose = () => {
    setModalContentMapper(null);
    setUploadedData(initialFileState);
  };

  const navigate = useNavigate();

  const getModalContent = () => {
    switch (modalContentMapper) {
      case "successModal":
        return successModalContent();

      case "uploadModal":
        return uploadModalContent();

      default:
        break;
    }
  };

  const registerTerminals = async (
    terminalDetails,
    resetForm,
    terminalId,
    registrationType = 2,
    file = ""
  ) => {
    let payload = terminalId
      ? terminalDetails[0]
      : {
          file,
          registrationType,
          terminalDetails,
        };

    let method = terminalId ? "put" : "post";
    let url = terminalId
      ? routes.updateTerminal(terminalId)
      : routes.registerTerminal();
    try {

      const { data } = await makeRequest(method, url, payload);
      if (isSuccessResponse(data)) {
        if (terminalId) {
          setAlert("Terminal Updated Successfully", "success");
          return navigate(ROUTES.manageTerminals);
        }
        resetForm();
        setResponseMessage(data.responseMessage);
        setModalContentMapper("successModal");
      } else {
        data.responseMessage && setAlert(data.responseMessage);
      }

      return;
    } catch (err) {}
  };

  const handleFileUpload = () => {
    console.log(uploadedData);
    handleClose();
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: ".csv",
    onDrop: useCallback(
      (uploadedFile) => {
        // if (uploadedFile[0].size > 4000000) {
        //   setUploadedData({
        //     ...uploadedData,
        //     error: "Maximum file size is 4MB",
        //   });
        // } else if (
        //   uploadedFile[0].name
        //     .substr(uploadedFile[0].name.length - 3)
        //     .toLowerCase() !== "csv"
        // ) {
        //   setUploadedData({
        //     ...uploadedData,
        //     error: "File must be in CSV",
        //   });
        // } else {
        // }

        if (uploadedFile.length) {
          setUploadedData({
            ...uploadedData,
            file: uploadedFile,
            error: "",
          });
        } else {
          setUploadedData({
            ...uploadedData,
            error: "File must be CSV format",
          });
        }
      },
      [uploadedData]
    ),
    multiple: false,
  });

  const successModalContent = () => (
    <div className="mt-3 px-4">
      <div className="mb-4">
        <div className="d-flex justify-content-end mb-2 cursor-pointer">
          <div className="bg-neutral px-1" onClick={handleClose}>
            <IoMdClose />
          </div>
        </div>
        <div className="text-center">
          <img src={successImg} alt="" width="110px" />
          <div className="success-modal-content">
            <Typography component="h5" variant="subtitle1" state="primary">
              Registration Successful!
            </Typography>
            <Typography variant="body3" state="primary" className="mt-4">
              {/* You will be notified in the next 48 hours when this terminal has
              been successfully authorized! */}
              {responseMessage}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );

  const uploadModalContent = () => (
    <div>
      <div
        className="bg-neutral d-flex justify-content-end"
        style={{ borderRadius: "1rem 1rem 0 0" }}
      >
        <div className="d-flex justify-content-between align-items-center p-3 upload-modal-header">
          <Typography state="primary" component="h5" variant="subtitle3">
            Upload File
          </Typography>
          <IoMdClose
            fontSize="20px"
            className="cursor-pointer"
            onClick={handleClose}
          />
        </div>
      </div>
      <div className="mt-3 px-3">
        <div {...getRootProps()} className="dragzone-container cursor-pointer">
          <input {...getInputProps()} />

          {uploadedData.file ? (
            <>
              <img src={fileImg} alt="" height="70" />
              <div className="text-center mt-3">
                <Typography variant="body2">
                  {uploadedData.file[0]?.name}
                </Typography>

                <Typography variant="body3">
                  <CgCheckR color="#27AE60" fontSize="12px" /> File Uploaded
                </Typography>
              </div>
            </>
          ) : (
            <>
              <img src={cloudImg} alt="" />
              <div className="mt-3">
                <Typography variant="body2" component="span">
                  Drop Files here or
                </Typography>{" "}
                <Typography variant="body2" component="span" state="secondary">
                  Browse
                </Typography>
              </div>
            </>
          )}
        </div>
        <div className="d-flex justify-content-between cursor-pointer mt-1">
          <Typography variant="caption1" state="danger">
            {uploadedData.error}
          </Typography>
          {uploadedData.file && (
            <Typography
              variant="caption1"
              onClick={() =>
                setUploadedData({ ...uploadedData, file: null, error: "" })
              }
            >
              Remove this file{" "}
              <AiOutlineDelete
                className="font-danger"
                fontSize="13px"
                style={{ marginTop: "-.2rem" }}
              />
            </Typography>
          )}
        </div>
        <TextField
          name="fileName"
          type="text"
          value={uploadedData.fileName}
          onChange={(e) =>
            setUploadedData({ ...uploadedData, fileName: e.target.value })
          }
          placeholder="Enter File Name"
          label="File Name"
          required={false}
          containerClassName="mt-4"
        />

        <div className="bulk-registration-cta">
          <Button
            label="Cancel"
            variant="secondary"
            size="xs"
            className="mx-4"
            onClick={handleClose}
          />
          <Button
            onClick={handleFileUpload}
            label="Proceed"
            size="xs"
            disabled={!uploadedData.file}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="dashboard-containter bg-light pt-2">
      <div style={{ margin: "0 2rem 1rem" }}>
        <BeadCrumb titles={["Terminals", "Register Terminal"]} />
      </div>

      <CustomHeader title="Register Terminal" titlePosition="center" />
      <div className="register-terminal-container">
        <AddCta
          text="Upload a file for alternate registration"
          onClick={() => setModalContentMapper("uploadModal")}
        />
        <div className="d-flex justify-content-end mt-1 mb-4">
          <span className="font-danger" style={{ marginTop: "-.3rem" }}>
            *
          </span>
          <Typography variant="caption1" component="span">
            Only CSV file formats are allowed
          </Typography>
        </div>

        <Typography variant="body2" component="h5" className="text-center mb-3">
          You can manually fill this{" "}
          {singleRegMode ? "form for terminal" : "table for multiple terminal"}{" "}
          registration
        </Typography>

        {!singleRegMode && (
          <div className="text-center" style={{ marginTop: "-1rem" }}>
            <Typography variant="caption1" component="span">
              Maximum of 20 entries are allowed
            </Typography>
          </div>
        )}

        <div className="d-flex justify-content-end my-3">
          <div
            className=" bulk-register-cta cursor-pointer"
            onClick={() => setSingleRegMode(!singleRegMode)}
          >
            <Typography variant="body4" state="primary">
              Click to register {!singleRegMode ? "individual" : "in bulk"}
            </Typography>
          </div>
        </div>
      </div>
      {singleRegMode ? (
        <SingleRegistration registerTerminal={registerTerminals} />
      ) : (
        <BulkRegistration registerTerminals={registerTerminals} />
      )}
      <Modal
        showModal={!!modalContentMapper}
        onClose={handleClose}
        customPadding={"p-0"}
      >
        {getModalContent()}
      </Modal>
    </div>
  );
};

export default RegisterTerminal;
